export const WORKTYPEGROUPLIST_SEARCH = 'WORKTYPEGROUPLIST_SEARCH';
export const WORKTYPEGROUPLIST_PAGE = 'WORKTYPEGROUPLIST_PAGE';
